import jaroWinkler from 'jaro-winkler';

export default function calculateSimilarity(str1:string, str2:string):number {
    if (!str1 || !str2) { 
       return 0;
    }

    const word1:string[] = str1?.toLowerCase().split(/\s+/);
    const word2:string[] = str2?.toLowerCase().split(/\s+/);
    const percentage:number = Math.round(jaroWinkler(word1?.join(' '), word2?.join(' ')) * 100);
    return percentage;
}
